<h1 mat-dialog-title>Standort wechseln</h1>
<div mat-dialog-content class="standort-dialog-content">
    <div class="form-section">
        <p *ngIf="!gruppeStandort?.gs_id">Aktueller Standort: {{ gruppe?.stall }}</p>
        <kiene-autocomplete
            #standortAutocomplete
            (deleteSelected)="deleteStall($event)"
            (elementSelected)="setStandort($event)"
            [displayFields]="['stall', 'sgs_nummer']"
            [emitFreeText]="true"
            [focus]="false"
            [genericApiUrl]="standortApiUrl"
            [kieneObject]="stall"
            [params]="params"
            [placeholder]="gruppeStandort?.gs_id ? 'Standort' : 'Neuer Standort'"
            [showDeleteButton]="true"
            separator=", "
        >
        </kiene-autocomplete>
    </div>

    <mat-form-field style="width: 100%" class="form-section">
        <mat-label>{{ gruppeStandort?.gs_id ? "" : "Neuer " }}Produktionsabschnitt</mat-label>
        <mat-select [compareWith]="produktionsabschnittComparator" [formControl]="produktionsabschnittCtrl">
            <mat-option *ngFor="let p of produktionsabschnitte" [value]="p">{{ p.produktionsabschnitt }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field style="width: 100%" class="form-section">
        <mat-label>Standort Datum Von</mat-label>
        <input
            [formControl]="datumVonCtrl"
            [matDatepicker]="standortVonPicker"
            [min]="minDatumVon"
            [readonly]="true"
            matInput
        />
        <mat-datepicker-toggle [for]="standortVonPicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #standortVonPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf="gruppeStandort?.gs_id" style="width: 100%" class="form-section">
        <mat-label>Standort Datum Bis</mat-label>
        <input [formControl]="datumBisCtrl" [matDatepicker]="standortBisPicker" [readonly]="true" matInput />
        <mat-datepicker-toggle [for]="standortBisPicker" matSuffix></mat-datepicker-toggle>
        <mat-datepicker #standortBisPicker></mat-datepicker>
    </mat-form-field>

    <ng-container *kienePermission="[9161]">
        <ng-container *ngIf="selectedTiere?.length > 0">
            <div class="weights-toolbar">
                <p class="weights-count"><strong>Gesamtanzahl Tiere:</strong> {{ selectedTiere.length }}</p>

                <mat-radio-group [formControl]="gewichtModusCtrl" class="gewicht-mode-group">
                    <mat-radio-button value="single">Gewicht pro Tier eingeben</mat-radio-button>
                    <mat-radio-button value="all">durchschnittlichestiergewicht</mat-radio-button>
                </mat-radio-group>

                <div class="weights-toolbar-actions">
                    <button mat-stroked-button color="accent" (click)="alteGewichteUebernehmen(true)">
                        Letztes Gewicht laden
                    </button>
                </div>
            </div>

            <mat-form-field *ngIf="gewichtModusCtrl.value === 'all'" style="width: 100%" class="form-section">
                <mat-label>Gewicht je Tier (fuer alle Tiere)</mat-label>
                <input [formControl]="gewichtAlleSelektiertCtrl" inputmode="decimal" matInput type="number" />
            </mat-form-field>

            <div *ngIf="gewichtModusCtrl.value === 'single'" class="tier-gewicht-list">
                <div *ngFor="let tier of selectedTiere" class="tier-gewicht-row">
                    <mat-form-field style="width: 100%">
                        <mat-label>{{ tier.ohrmarke_notnull || ("Tier " + tier.gt_id) }}</mat-label>
                        <input [formControl]="tier.gewichtCtrl" inputmode="decimal" matInput type="number" />
                    </mat-form-field>
                </div>
            </div>

            <p *ngIf="selectedTiereTotalGewicht !== null">
                Gesamtgewicht: <strong>{{ selectedTiereTotalGewicht }}</strong> kg
            </p>
        </ng-container>

        <ng-container *ngIf="showGewicht">
            <mat-hint
                >Das eingetragene Gewicht wird bei diesem Standort als Einstallgewicht gespeichert und als
                Abgangsgewicht beim vorherigen Standort.
            </mat-hint>

            <mat-form-field style="width: 100%">
                <mat-label>Gesamtgewicht</mat-label>
                <input [formControl]="gesamtgewichtCtrl" inputmode="decimal" matInput type="number" />
            </mat-form-field>

            <mat-form-field style="width: 100%">
                <mat-label>&Oslash; Durchschnittsgewicht</mat-label>
                <input [formControl]="durchschnittsgewichtCtrl" inputmode="decimal" matInput type="number" />
            </mat-form-field>
        </ng-container>

    </ng-container>
</div>
<div mat-dialog-actions class="standort-dialog-actions">
    <button (click)="close()" mat-button>Schlie&szlig;en</button>
    <button (click)="save()" color="accent" mat-flat-button
        >Standort {{ gruppeStandort?.gs_id ? "Speichern" : "Wechseln" }}
    </button>
</div>
